import PropTypes from 'prop-types';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { RouterLink } from 'src/routes/components';
import { getPathAfterLogin } from 'src/layouts/dashboard/config-navigation';

const Logo = ({ isFull = false, sx }) => {
  const logo = (
    <Box
      component="img"
      alt="logo"
      src={`/logo/logo_${isFull ? 'full' : 'single'}.svg`}
      sx={{
        display: 'inline-flex',
        height: 40,
        width: isFull ? 132 : 40,
        cursor: 'pointer',
        ...sx,
      }}
    />
  );

  return (
    <Link
      aria-label="logo"
      component={RouterLink}
      href={getPathAfterLogin() || '/'}
      sx={{ display: 'contents' }}
    >
      {logo}
    </Link>
  );
};

Logo.propTypes = {
  isFull: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
